import React, { Component, Fragment } from 'react'
import {TextInput,
        DateInput
    } from 'react-admin'
import {RichTextInput} from 'ra-input-rich-text';


class EditDetails extends Component {
    constructor(props) {
        console.log(props)
        super(props);
        this.state = { data: props.data, ftype: props.ftype, render: false };

    }

    componentDidMount() {
        setTimeout(function() { //Start the timer
            this.setState({render: true}) //After 1 second, set render to true
        }.bind(this), 100)

    }

    render () {
        var final = [];
        var queue = [];

       for(var i=1;  i < (this.state.data.det_count + 1); i++){

        queue.push(<tr >
                    <td style={{fontWeight:'bold'}}> <TextInput source={`proced_${i}`}  label='' fullWidth multiline disabled/>
                                                     <TextInput source={`id_${i}`} style={{ display: 'none', visibility: 'hidden'}} /></td>
                    <td><DateInput source={`read_date_${i}`}    label="" locales="en-us"  locales="en-us"/></td>
                    <td><TextInput source={`emp_init_${i}`} label="" /></td>
                    <td><DateInput source={`emp_init_date_${i}`}    label="" locales="en-us"  locales="en-us"/></td>
                </tr>)
        }

        if(this.state.render) {
            final = queue;
        }

        return (
            <>{final}</>
        )
    }
}

export default EditDetails